import * as yup from "yup";
import i18n from "i18next";

export const createGroupValidationSchema = () => {
  yup.setLocale({
    number: {
      positive: i18n.t("validation.field.positive.number"),
    },
    mixed: {
      required: i18n.t("validation.field.required"),
    },
  });

  const registrationValidationSchema = yup.object({
    position: yup.number().typeError(i18n.t("validation.field.positive.number")).positive(),
  });

  return registrationValidationSchema;
};

export const createSubGroupValidationSchema = () => {
  yup.setLocale({
    number: {
      positive: i18n.t("validation.field.positive.number"),
    },
    mixed: {
      required: i18n.t("validation.field.required"),
    },
  });

  const registrationValidationSchema = yup.object({
    position: yup.number().typeError(i18n.t("validation.field.positive.number")).positive(),
  });

  return registrationValidationSchema;
};

export const createLinkValidationSchema = () => {
  yup.setLocale({
    number: {
      positive: i18n.t("validation.field.positive.number"),
    },
    mixed: {
      required: i18n.t("validation.field.required"),
    },
  });

  const registrationValidationSchema = yup.object({
    name: yup.string().required(),
    nameEn: yup.string().required(),
    link: yup.string().required(),
    position: yup.number().typeError(i18n.t("validation.field.positive.number")).positive(),
  });

  return registrationValidationSchema;
};
